export default {
  surnames: [],
  registerReferralData: null,
};
